<template>
  <CCard @click="redirectToRouteName" type="button" class="mt-3 mb-0 p-4 card-option border-gray-200" :class="{ '--disabled': isOptionDisabled }">
    <CContainer>
      <CRow class="d-flex justify-content-between mb-2">
        <h1 class="text-primary font-xl">{{ optionTitle }}</h1>
        <CBadge v-if="hasBadge" color="primary">{{ $t('automation.new.step-1.card.option.badge') }}</CBadge>
      </CRow>
      <CRow>
        <p class="m-0 text-gray-600">{{ optionDescription }}</p>
      </CRow>
    </CContainer>
  </CCard>
</template>

<script>
export default {
  name: "AutomationNewCardOption",
  props: {
    optionTitle: {
      type: String,
      required: true
    },
    optionDescription: {
      type: String,
      required: true
    },
    hasBadge: {
      type: Boolean,
      default: false,
    },
    isOptionDisabled: {
      type: Boolean,
      default: false,
    },
    optionRouteName: {
      type: String
    }
  },
  methods: {
    redirectToRouteName() {
      this.$router.push({ name: this.optionRouteName })
    },
  }
}
</script>

<style lang="scss">
.card-option {
  width: 278px;

  &.--disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: var(--purple-50) !important;
  }
}
</style>